import { memo } from "react";

const Wallet = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_276_2813)">
      <path d="M20 0H0V20H20V0Z" fill="white" fillOpacity="0.01" />
      <path
        d="M1.66667 3.33331H18.3333V6.66665C18.3333 6.66665 14.1667 7.49998 14.1667 9.99998C14.1667 12.5 18.3333 13.3333 18.3333 13.3333V16.6666H1.66667V3.33331Z"
        stroke="currentColor"
        strokeWidth="1.53846"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 10H17.5"
        stroke="currentColor"
        strokeWidth="1.53846"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_276_2813">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default memo(Wallet);
